(() => {
  const selector = '.template-index .pl-combo-grid';

  const init = root => {
    root.querySelectorAll(selector).forEach(track => {
      if (track.dataset.dragReady) return;
      track.dataset.dragReady = 'true';

      let startX = 0;
      let startScroll = 0;
      let dragging = false;
      let moved = false;

      track.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || window.innerWidth > 767) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', event => {
        if (!dragging) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 4) moved = true;
        track.scrollLeft = startScroll - distance;
      });

      const stop = event => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      };

      track.addEventListener('pointerup', stop);
      track.addEventListener('pointercancel', stop);
      track.addEventListener('click', event => {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      }, true);
    });

    // Touch-pause for category marquee on mobile
    root.querySelectorAll('.pl-category-marquee').forEach(marquee => {
      if (marquee.dataset.touchReady) return;
      marquee.dataset.touchReady = 'true';

      let timer = null;
      marquee.addEventListener('touchstart', () => {
        clearTimeout(timer);
        marquee.classList.add('is-touching');
      }, { passive: true });

      const resume = () => {
        timer = setTimeout(() => {
          marquee.classList.remove('is-touching');
        }, 350);
      };

      marquee.addEventListener('touchend', resume, { passive: true });
      marquee.addEventListener('touchcancel', resume, { passive: true });
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
